import React, { Component } from "react";
// import { Notification, TextInputSkeleton } from "carbon-components-react";
import Modal from "@acadia-ui/modal";
// import "carbon-components/scss/components/notification/_inline-notification.scss";
import { onStateChange } from "events";
import ErrorHelpers from "../../Components/FormBuilder/ErrorHelpers";
import FormBuilderV2 from "../../Components/FormBuilder/FormBuilderV2";
import { putLineItem, fetchOnlyLineItemConfig } from "../../Flux/Actions/LineItemActions";
import UpdateStateHelper from "../../Components/FormBuilder/UpdateStateHelper";
import ModalHelpers from "../Modals/ModalHelpers";
import LineItemDataStore from "../../Flux/Stores/LineItemDataStore";
import InsertionOrderDataStore from "../../Flux/Stores/InsertionOrderDataStore";
import MasterCampaignsStore from "../../Flux/Stores/MasterCampaignsStore";
import BookFiltersStore from "../../Flux/Stores/BookFiltersStore";
import "./modal.scss";
import moment from "moment";
import Loading from "../../Components/LoadingSpinner";
import Button from "@acadia-ui/button";
import { showToast, TOAST_TYPE, ToastNotification } from "@acadia-ui/toast";

const initialState = {
	formData: {},
	postData: {},
	errors: {},
	showErrors: false,
	isFormDataValid: false
};

const formEl = "create_lineitem";

class NewLineItem extends Component {
	constructor(props) {
		super(props);
		this.state = {
			metaData: {
				StartDate: this.props.metaData.StartDate ? moment(this.props.metaData.StartDate).format("YYYY/MM/DD") : null,
				EndDate: this.props.metaData.EndDate ? moment(this.props.metaData.EndDate).format("YYYY/MM/DD") : null
			},
			loading: false,
			...initialState,
			isShow: false
		};
	}

	componentDidMount() {
		this.props.newLineItem(this);
		LineItemDataStore.on("lineitems_fail", this.handleErrors);
		LineItemDataStore.on("lineitems__errors__reset", this.handleReset);
		LineItemDataStore.on("lineitems_success", this.handleSuccess);
		LineItemDataStore.on("create_and_add_lineitems_success", this.handleCreateAnotherSuccess);
		this.setInitialFormData();
	}

	componentDidUpdate(prevProps, prevState) {
		this.isValidFormData();
	}

	componentWillUnmount() {
		this.props.newLineItem(undefined);
		LineItemDataStore.removeListener("lineitems_fail", this.handleErrors);
		LineItemDataStore.removeListener("lineitems__errors__reset", this.handleReset);
		LineItemDataStore.removeListener("lineitems_success", this.handleSuccess);
		LineItemDataStore.removeListener("create_and_add_lineitems_success", this.handleCreateAnotherSuccess);
	}

	setInsertionOrderData = (defaultValue) => {
		window.setTimeout(() => {
			if (defaultValue) {
				this.setState({ loading: true }, () => {
					const form = this.state.formData;
					form.ParentDescription = { disabled: false, value: defaultValue };
					this.setState({ formData: form });
					this.handleParentChange(defaultValue.value);
				});
			}
		}, 50);
	};

	parentChanged = () => {
		const defaultValue = InsertionOrderDataStore.getDefaultValue();
		if (defaultValue !== null) {
			this.setInsertionOrderData(defaultValue);
			const { postData } = this.state;
			postData.ParentData = { ParentUniqueIdCode: defaultValue.value, ParentDescription: defaultValue.value };
			this.setState({ postData });
			InsertionOrderDataStore.resetDefaultValue();
		}

		if (InsertionOrderDataStore.getNavigate()) {
			this.triggerOpenClose();
			InsertionOrderDataStore.setNavigate(false);
		}
	};

	handleSuccess = () => {
		InsertionOrderDataStore.updateChildCount(this.state.postData?.ParentData?.ParentDescription);
		this.setState({ loading: false }, () => {
			this.triggerOpenClose();
			this.props.updateCounts("LineItem");
		});
		showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.SUCCESS} message="Line item added successfully." timed={5000} />);
	};

	handleErrors = () => {
		this.setState({ loading: false }, () => {
			const errors = LineItemDataStore.getErrors();
			if (Object.keys(errors).length > 0) {
				const lineItemErrors = errors;
				const type = "create--lineitem";
				this.setState({ errors: lineItemErrors, showErrors: true }, () => {
					ErrorHelpers.displayErrors(formEl, this.state.errors, type);
					showToast("workbookToasts", <ToastNotification type={TOAST_TYPE.ERROR} message="Line item could not be added." />);
				});
			}
		});
	};

	/* Needed for all Modals */
	triggerOpenClose = (hardReset) => {
		if (this.state.loading === false) {
			const actualInitialState = {
				formData: {},
				postData: {},
				errors: {},
				showErrors: false,
				isFormDataValid: false
			};

			// initialstate gets polluted. Unfortunately, that polluted is needed all over the place. So we reset it here when called for.
			ModalHelpers.openClose(null, this.updateModalState, this.state, hardReset ? actualInitialState : initialState, () => {
				if (hardReset) {
					this.setInitialFormData();
				}
				if (!this.state.open) {
					UpdateStateHelper.matchParentValues(this, this.props.config);
					this.isValidFormData();
				} else {
					const { postData } = this.state;
					delete postData?.ParentData;
					delete postData?.LineItemData?.InsertionOrderID;
					this.setState({ postData });
				}
				ErrorHelpers.resetErrors(formEl);
			});
		}
	};

	setInitialFormData = () => {
		this.handleReset();
		const configObjs = Object.entries(this.props.config);
		const { formData } = this.state;
		for (const dataBucket of configObjs) {
			if (dataBucket[0] != "ChildData") {
				for (const field of dataBucket[1]) {
					if (field.Name && field?.FieldType != "Hidden") {
						formData[field.Name] = { disabled: false, parentName: null, value: "" };
					}
				}
			}
		}
		this.setState({ formData });
	};

	isValidFormData = () => {
		const { formData } = this.state;
		let isValid = true;
		for (const key in formData) {
			if (Object.hasOwn(formData, key)) {
				const { value } = formData[key];
				const isDisabled = formData[key].disabled;
				const ignoreKeys = ["ParentDescription"];
				if ((value == "" || value == null || value == undefined || value == "0.00") && !isDisabled && !ignoreKeys.includes(key)) {
					isValid = false;
				}
			}
		}
		if (this.state.isFormDataValid !== isValid) {
			this.setState({ isFormDataValid: isValid });
		}
	};

	updateModalState = (args) => {
		this.setState(args);
	};
	/* END */

	handleReset = () => {
		ErrorHelpers.resetErrors(formEl);
	};

	handleParentChange = (parentInsertionOrderID) => {
		const parentData = InsertionOrderDataStore.getData().find((io) => {
			return io.InsertionOrderID === parentInsertionOrderID;
		});
		this.setState(
			{
				metaData: {
					StartDate: parentData.StartDate ? moment(parentData.StartDate).format("YYYY/MM/DD") : null,
					EndDate: parentData.EndDate ? moment(parentData.EndDate).format("YYYY/MM/DD") : null
				},
				loading: false
			},
			() => {
				const newFormData = { ...this.state.formData };
				const newPostData = { ...this.state.postData };
				Object.keys(this.props.config).forEach((bucket) => {
					if (["LineItemData", "TaxonomyData", "MetaData"].includes(bucket)) {
						this.props.config[bucket].forEach((dataKey) => {
							let postDataValue = {};
							let formDataValue = {};
							if (parentData[dataKey.Name] && dataKey.FieldType !== "Hidden") {
								postDataValue = {
									[dataKey.Name]: {
										dataKeyID: dataKey.ID
									}
								};
								formDataValue = {
									[dataKey.Name]: {
										disabled: false,
										parentName: dataKey.ParentName
									}
								};
								if (dataKey.FieldType !== "Select") {
									const formattedValue = dataKey.FieldType !== "Date" ? parentData[dataKey.Name] : moment(parentData[dataKey.Name]).format("YYYY/MM/DD");
									if (bucket !== "LineItemData") {
										postDataValue[dataKey.Name].dataValueIfFreeForm = formattedValue;
									} else {
										postDataValue[dataKey.Name] = formattedValue;
									}
									formDataValue[dataKey.Name].value = formattedValue;
								} else {
									const matchedOption = dataKey.Options.find((option) => {
										return option.OptionLabel === parentData[dataKey.Name];
									});
									if (matchedOption) {
										postDataValue[dataKey.Name].dataValue = {
											dataValueID: matchedOption.OptionID
										};
										formDataValue[dataKey.Name].value = { value: matchedOption.OptionID, label: matchedOption.OptionLabel };
									}
								}
								if (formDataValue[dataKey.Name].value) {
									if (!newPostData[bucket]) {
										newPostData[bucket] = {};
									}
									Object.assign(newPostData[bucket], postDataValue);
									Object.assign(newFormData, formDataValue);
								}
							}
						});
					}
				});
				this.setState({ formData: newFormData, postData: newPostData }, () => {
					this.isValidFormData();
				});
			}
		);
	};

	updateState = (dataConfig, name, value, id, dataType, calc, disabled) => {
		if (this.state.loading === false) {
			// The reference to THIS is used to update the proper state
			if (dataConfig === "ParentData") {
				this.setState({ loading: true }, () => {
					if (value !== null) {
						this.handleUpdate(dataConfig, name, value, id, dataType, disabled);
						this.handleParentChange(value.value);
					} else {
						this.setState(
							{
								metaData: {
									StartDate: moment(this.props.metaData.StartDate).format("YYYY/MM/DD"),
									EndDate: moment(this.props.metaData.EndDate).format("YYYY/MM/DD")
								},
								formData: {},
								postData: {},
								loading: false
							},
							() => {
								this.handleUpdate(dataConfig, name, value, id, dataType, disabled);
							}
						);
					}
				});
			} else {
				this.handleUpdate(dataConfig, name, value, id, dataType, disabled);
			}
		}
	};

	handleUpdate = (dataConfig, name, value, id, dataType, disabled) => {
		UpdateStateHelper.update(dataConfig, name, value, id, dataType, true, formEl, this, disabled, this.props.config, false, this.isValidFormData());
	};

	sortTaxonomyData = (taxonomyData) => {
		const taxDataWithPositions = taxonomyData;
		taxDataWithPositions.forEach((taxonomyField) => {
			if (this.props.config.TaxonomyData) {
				this.props.config.TaxonomyData.forEach((taxFieldConfig) => {
					if (taxFieldConfig.ID === taxonomyField.dataKeyID) {
						taxonomyField.Position = taxFieldConfig.Position;
					}
				});
			}
		});
		taxDataWithPositions.sort((a, b) => {
			if (a.Position < b.Position) {
				return -1;
			}
			if (a.Position > b.Position) {
				return 1;
			}
			return 0;
		});
		taxDataWithPositions.forEach((taxonomyField) => {
			delete taxonomyField.Position;
		});
		return taxDataWithPositions;
	};

	/* This should be a helper object that formats POST JSON for the PUT Actions */
	formDataObjForPost = (newRowObj) => {
		if (Object.keys(newRowObj).length > 0) {
			const postData = { ...this.state.postData };
			let strippedTaxonomyPostData = [];

			/* Removes the Key from the Taxonomy Data Array : Theja's Post does not like it */
			for (const i in postData.TaxonomyData) {
				strippedTaxonomyPostData.push(postData.TaxonomyData[i]);
			}
			strippedTaxonomyPostData = this.sortTaxonomyData(strippedTaxonomyPostData);
			const strippedMetadataPostData = [];
			for (const i in postData.MetaData) {
				strippedMetadataPostData.push(postData.MetaData[i]);
			}
			postData.MetaData = strippedMetadataPostData;
			/* postData is a copy of the state, so we just overwrite the innards with our new array */
			postData.TaxonomyData = strippedTaxonomyPostData;
			const filters = BookFiltersStore.getChoicesState();
			const campaignUniqueID = MasterCampaignsStore.getParentCampaignUniqueID();
			/* Config will hold the ID's of the filters */
			const PlatformID = filters.platform.value;
			const AuditLevelID = this.props.auditLevelID;
			const contextValues = BookFiltersStore.getContextValues();
			const formSubmissionObj = {
				MasterAgencyDivisionName: contextValues?.agency?.name,
				MasterBusinessUnitName: contextValues?.client?.name,
				MasterCountryCode: contextValues?.country?.name,
				ContextID: contextValues.contextId,
				PlatformID,
				AuditLevelID,
				MasterRegionCode: contextValues?.region?.name,
				CampaignUniqueIDCode: campaignUniqueID,
				...postData
			};

			return formSubmissionObj;
		}
		this.setState({ errors: { Errors: ["Please fill in all form fields."] }, showErrors: true }, () => {
			ErrorHelpers.displayErrors(formEl, this.state.errors);
		});
	};

	handleSubmit = (e) => {
		if (this.state.loading === false) {
			this.setState({ loading: true }, () => {
				this.sendPostObject(this.state.formData, true);
			});
		}
	};

	handleCreateAnother = (e) => {
		if (this.state.loading === false) {
			this.setState({ loading: true }, () => {
				this.sendPostObject(this.state.formData, false);
			});
		}
	};

	handleCreateAnotherSuccess = () => {
		InsertionOrderDataStore.updateChildCount(this.state.postData?.ParentData?.ParentDescription);
		this.setState({ loading: false }, () => {
			this.handleReset();
			this.props.updateCounts("LineItem");
		});
		this.setState({ isShow: true }, () => {
			setTimeout(() => {
				this.setState({ isShow: false });
			}, 3000);
		});
		if (this.state.isShow === true) {
			const element = document.getElementsByClassName("showMessage");
			if (element.length !== 0) {
				if (element[0] !== undefined) {
					element[0].scrollIntoView();
				}
			}
		}
	};

	sendPostObject = (newRowObj, closeModal) => {
		this.postObject = this.formDataObjForPost(newRowObj);
		if (this.postObject) {
			if (this.postObject.LineItemData) {
				this.postObject.LineItemData.UniqueID = 1;
			} else {
				this.postObject.LineItemData = {
					UniqueID: 1
				};
			}
			if (this.state.postData.ParentData?.ParentDescription) {
				this.postObject.LineItemData.InsertionOrderID = this.state.postData.ParentData.ParentDescription;
			}
			const arrayPostObject = [this.postObject];
			const updatedData = putLineItem(arrayPostObject, closeModal);
		}
		if (this.postObject === undefined) {
			this.setState({ loading: false });
		}
	};

	render() {
		/* Temp Test Function -- Loads a skeleton if nothing there yet */
		const isDisabled = this.state.loading ? "disabledModal" : "";
		let formInnards;
		if (this.props.config) {
			if (Object.keys(this.props.config).length !== 0) {
				formInnards = (
					<FormBuilderV2
						// fieldsDisabled={!this.state.postData.ParentData || Object.keys(this.state.postData.ParentData).length === 0}
						type="create lineitem"
						data={this.props.config}
						configName="lineItemConfig"
						onUpdate={this.updateState}
						state={this.state}
						rerenderDP={true}
						auditLevelID={this.props.auditLevelID}
					/>
				);
			} else {
				formInnards = <div></div>;
			}
		}

		return (
			<>
				<Modal
					id={formEl}
					heading="Add Line Item"
					description="Enter the information below, then click the Add button to create a new Add Line Item, or click on Create and Add Another to add another Inline Items."
					isOpen={this.state.open}
					onRequestClose={() => {
						if (this.state.open) {
							this.triggerOpenClose();
						}
					}}
					size="medium"
					userClosable={true}
					onClick={() => {}}
					actionSetProps={{
						actionsLeft: (
							<Button className="first-button" display="secondary" onClick={this.triggerOpenClose} data-tracking-id-alt="cancel-add-line-item">
								Cancel
							</Button>
						),
						actionsRight: (
							<>
								<Button
									className="second-button"
									display="secondary"
									disabled={!this.state.isFormDataValid}
									onClick={this.handleCreateAnother}
									data-tracking-id-alt="create-add-another-line-item"
								>
									Create and add another
								</Button>
								<Button
									className="third-button"
									display="primary"
									disabled={!this.state.isFormDataValid}
									onClick={this.handleSubmit}
									data-tracking-id-alt="confirm-add-line-item"
								>
									Add
								</Button>
							</>
						)
					}}
				>
					{this.state.isShow && <p className="showMessage">Previous Line Item has been created successfully!</p>}
					{this.state.loading ? (
						<Loading className="modalLoading" />
					) : (
						<form autoComplete="off">
							<div className="form__group__container _m-t--10 _m-b--10">{formInnards}</div>
							{this.state.showErrors && <div id="errors__container" />}
						</form>
					)}
				</Modal>
			</>
		);
	}
}

export default NewLineItem;
